import anime from "animejs";
import EventEmitter2 from "eventemitter2";

import Breakpoint from "@utils/breakpoint";
import { $, $$, rect } from "@utils/dom";
import { on, off } from "@utils/listener";
import Viewport from "@utils/viewport";

const OPENED_CLASSNAME = '--js-opened';

class SiteFooter {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.secondLevelMenus = [ ...$$('.site-footer__nav > ul > li.menu-item-has-children', this.el) ].map(el => new SecondLevelMenu(el));
    this.thirdLevelMenus = [ ...$$('.site-footer__nav > ul > li > ul > li.menu-item-has-children', this.el) ].map(el => new ThirdLevelMenu(el));
    this.newsletter = $('.site-footer__newsletter', this.el);
    this.bottom = $('.site-footer__bottom', this.el);

    this._bp = null;

    this._onResize = this._onResize.bind(this);
    this._onSecondLevelMenuClicked = this._onSecondLevelMenuClicked.bind(this);
    this._onThirdLevelMenuClicked = this._onThirdLevelMenuClicked.bind(this);
  }

  init() {
    this._bp = Breakpoint(['(min-width: 768px)'], this._onResize);
    this._bp.run();

    this._bindEvents();
  }
  destroy() {
    if( this._bp ) this._bp.dispose();
    if( this.secondLevelMenus ) this.secondLevelMenus.forEach(menu => menu.destroy());
    if( this.thirdLevelMenus ) this.thirdLevelMenus.forEach(menu => menu.destroy());

    this.el = null;
    this.emitter = null;
    this.secondLevelMenus = null;
    this.thirdLevelMenus = null;
    this.newsletter = null;
    this.bottom = null;

    this._bp = null;

    this._onResize = null;
    this._onSecondLevelMenuClicked = null;
    this._onThirdLevelMenuClicked = null;
  }

  stop() { this._unbindEvents(); }

  _bindEvents() {
    this._bp.on();
    this.secondLevelMenus?.forEach(menu => menu.on('click', this._onSecondLevelMenuClicked));
    this.thirdLevelMenus?.forEach(menu => menu.on('click', this._onThirdLevelMenuClicked));
  }
  _unbindEvents() {
    this._bp.off();
    this.secondLevelMenus?.forEach(menu => menu.off('click', this._onSecondLevelMenuClicked));
    this.thirdLevelMenus?.forEach(menu => menu.off('click', this._onThirdLevelMenuClicked));
  }

  _onResize() {
    const buttonMode = Viewport.width < 768;
    this.secondLevelMenus?.forEach(menu => menu.buttonMode = buttonMode);
  }
  _onSecondLevelMenuClicked(menu) {
    menu.el.classList.toggle(OPENED_CLASSNAME);
    this.emitter.emit('SiteScroll.update');
  }
  _onThirdLevelMenuClicked(menu) {
    // save bottom BCR's before DOM is updated
    const startBCR = rect(this.bottom);

    // update DOM & SiteScroll
    menu.el.classList.add(OPENED_CLASSNAME);
    this.emitter.emit('SiteScroll.update');

    // save bottom BCR's after DOM as been updated
    const endBCR = rect(this.bottom);

    // compute amount of pixels this.bottom has to move
    const y = startBCR.y - endBCR.y;

    // prepare animation
    const timeline = anime.timeline({ duration: 850, easing: 'easeOutCubic', autoplay: false });

    timeline.add({
      targets: Viewport.width < 1200 ? [this.newsletter, this.bottom] : this.bottom,
      translateY: [y, 0],
    }, 0);

    timeline.add({
      targets: menu.menu,
      translateY: ['-100%', '0%'],
    }, 0);

    // start animation
    timeline.play();

    // scroll to bottom
    this.emitter.emit('SiteScroll.scrollTo', 'bottom', {smooth: true});
  }
}

class SecondLevelMenu extends EventEmitter2 {
  constructor(el) {
    super();

    this.el = el;
    this.button = $(':scope > *:first-child', this.el);

    this._buttonMode = false;
    this._onBtnClick = this._onBtnClick.bind(this);

    this.init();
  }

  init() {
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    this.el = null;
    this.button = null;

    this._buttonMode = null;
    this._onBtnClick = null;
  }

  _bindEvents() {
    on(this.button, 'click', this._onBtnClick);
  }
  _unbindEvents() {
    off(this.button, 'click', this._onBtnClick);
  }

  _onBtnClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.emit('click', this);
  }



  // getter - setter
  get buttonMode() { return this._buttonMode; }
  set buttonMode(value) {
    if( this._buttonMode === value ) return;
    this._buttonMode = value;

    if( this._buttonMode ) {
      this.button.setAttribute('role', 'button');
    } else {
      this.button.removeAttribute('role');
    }
  }
}

class ThirdLevelMenu extends EventEmitter2 {
  constructor(el) {
    super();

    this.el = el;
    this.button = $(':scope > *:first-child', this.el);
    this.menu = $(':scope > ul', this.el);

    this._onBtnClick = this._onBtnClick.bind(this);

    this.init();
  }

  init() {
    if( this.el.parentElement ) {
      const length = $$(':scope > li', this.el.parentElement).length - 1;
      this.el.style.setProperty('--row-end', length);
    }

    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    this.el = null;
    this.button = null;
    this.menu = null;

    this._onBtnClick = null;
  }

  _bindEvents() {
    on(this.button, 'click', this._onBtnClick);
  }
  _unbindEvents() {
    off(this.button, 'click', this._onBtnClick);
  }

  _onBtnClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.emit('click', this);
  }
}

export default SiteFooter;
